/** Shared Task history column sizing; names and order come from the server's single history view. */
import { ServiceHistoryRow } from '@jms/model';
import { EntityBoardColumnOverrides } from '@workbuddy/ui/v2/blocks/entity.board/context';
import { PlannedWorkCol } from '../../shared/planned.work.board.columns';

/** Both portal and tenant boards use these widths; embedded hosts may hide their redundant parent address. */
export const serviceHistoryColumns: EntityBoardColumnOverrides<ServiceHistoryRow> = {
  byField: {
    siteZone: PlannedWorkCol.tag,
    siteCategory: PlannedWorkCol.tag,
    siteAddress: PlannedWorkCol.site,
    serviceType: PlannedWorkCol.tag,
    serviceScope: PlannedWorkCol.tag,
    frequency: PlannedWorkCol.frequency,
    name: PlannedWorkCol.title,
    job: PlannedWorkCol.job,
    resolution: PlannedWorkCol.status,
    dueDate: PlannedWorkCol.date,
    rescheduledDate: PlannedWorkCol.date,
    completedOn: PlannedWorkCol.date,
    overdueDays: { width: 160, flex: 0 },
    resolutionReason: PlannedWorkCol.description,
    resolutionNotes: PlannedWorkCol.description,
    // Optional reporting columns remain sized when selected in an older view.
    date: PlannedWorkCol.date,
    site: PlannedWorkCol.site,
    serviceLine: PlannedWorkCol.line,
    earliest: PlannedWorkCol.date,
    latest: PlannedWorkCol.date,
    approvedFor: PlannedWorkCol.date,
    completionStatus: PlannedWorkCol.status,
    result: PlannedWorkCol.result,
  },
};
